<template>
<div class="site-detail">
    <Error @reload="getData()" v-if="networkError" />
    <div class="intro-page" v-else-if="showPage">
        <div class="banner-wrapper" v-if="hotel.images.length > 0">
            <div class="scroll-content">
                <img v-for="(item, index) in hotel.images" 
                        :key="`img-${index}`"
                        :class="hotel.images.length > 1 ? 'banner-img' : 'single-img'"
                        v-lazy="generateObj(item.image)"/>
                <div class="check-album" @click="handlePreivew">
                    <div class="check-text">
                        <div class="text">{{ $t('poi.seeAll') }}</div>
                        <div class="text">{{ $t('poi.total') }}{{ hotel.images.length }}{{ $t('poi.piece') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <img v-else class="single-img" src="/image/default_img.jpg"/>
        <div class="intro-wrapper">
            <div class="intro-brief">
                <div class="intro-name">{{ hotel.name }}</div>
                <div class="place-rate" v-if="hotel.rating || hotel.reviews">
                    <v-score v-if="hotel.rating" :rating="hotel.rating" />
                    <div class="place-review" v-if="hotel.reviews">{{ hotel.reviews }} {{ $t('home.comment') }}</div>
                </div>
            </div>
            <v-detail-content :detailArray="guideArray" :site="hotel" siteType="hotel" />
        </div>
        <!-- 酒店专属内容 -->
        <v-hotel-content :hotel="hotel" />
        <div class="explore-around">
            <v-explore-list :sites="recommend.sites" :hotels="recommend.hotels" :merchants="recommend.merchants" />
        </div>
    </div>
</div>
</template>

<script>
import Error from '@/components/Error.vue'
import Score from '@/components/Score.vue'
import DetailContent from '@/components/scenic/DetailContent.vue'
import ExploreList from '@/components/scenic/ExploreList.vue'
import HotelContent from '@/components/scenic/HotelContent.vue'
import { getHotelDetail } from '@/fetch/api'

export default {
    data () {
        return {
            showPage: false,
            hotel: {images: []},
            hotels: [],
            hotelId: '',
            recommend: {},
            bannerImages: [],
            guideArray: [],
            networkError: false
        }
    },
    components: {
        Error,
        'v-score': Score,
        'v-detail-content': DetailContent,
        'v-explore-list': ExploreList,
        'v-hotel-content': HotelContent
    },
    created () {
        document.title = this.$t('poi.hotelTitle')
        this.toast = this.$createToast({
            time: 0,
            txt: this.$t('common.loadingMsg'),
            mask: true
        })
        this.toast.show()
        navigator.geolocation.getCurrentPosition((res) => {
            const longitude = res.coords.longitude
            const latitude = res.coords.latitude
            this.geoData = {
                lon: longitude,
                lat: latitude
            }
            // console.log(longitude, latitude)
            if (longitude) {
                this.getData()
            }
        }, err => {
            this.geoData = {
                lon: 103.82241,
                lat: 1.2651
            }
            this.getData()
        }, { timeout: 5000, enableHighAccuracy: true })
    },
    watch: {
        '$route' () {
            this.getData()
        }
    },
    methods: {
        generateObj (src) {
            return {
                src,
                error: '/image/default_img.jpg',
                loading: '/image/loading-img.jpg'
            }
        },
        getData () {
            const params = {
                lon: this.geoData.lon,
                lat: this.geoData.lat
            }
            if (this.$route.query.language === 'zh') {
                params.locale = 'cn'
            } else {
                params.locale = 'en'
            }
            getHotelDetail(this.$route.params.id, params).then(res => {
                this.networkError = false
                this.hotel = res.hotel,
                this.recommend = {
                    sites: res.sites,
                    hotels: res.hotels,
                    merchants: res.merchants
                },
                this.guideArray = this.processGuide(res.hotel)
                this.bannerImages = res.hotel.images.slice(0, 6)
                this.showPage = true
                this.toast.hide()
                window.scrollTo(0,0)
            }).catch(err => {
                console.log(err)
                this.toast.hide()
                this.networkError = true
            })
        },
        processGuide (site) {
            let guideArray = []
            if (site.description) {
                guideArray.push({
                    id: 'description',
                    text: this.$t('poi.hotelDesc'),
                    content: site.description
                })
            }
            if (site.opened_at) {
                guideArray.push({
                    id: 'time',
                    text: this.$t('poi.hotelTime'),
                    content: site.opened_at
                })
            }
            if (site.contact_number) {
                guideArray.push({
                    id: 'number',
                    text: this.$t('poi.number'),
                    content: site.contact_number
                })
            }
            if (site.website) {
                guideArray.push({
                    id: 'website',
                    text: this.$t('poi.website'),
                    content: site.website
                })
            }
            if (site.traffic_strategy) {
                guideArray.push({
                    id: 'traffic',
                    text: this.$t('poi.traffic'),
                    content: site.traffic_strategy
                })
            }
            if (site.address) {
                guideArray.push({
                    id: 'address',
                    text: this.$t('poi.address'),
                    content: site.address
                })
            }
            return guideArray
        },
        // 查看相册
        handlePreivew () {
            this.$store.commit('SET_ALNUM', {
                previewImages: this.hotel.images,
                imageFolders: this.hotel.image_folders
            })
            let url = '/album'
            if (this.$route.query.language === 'zh') url += '?language=zh'
            this.$router.push(url)
        },
    }
}
</script>

<style lang="scss" scoped>
/* pages/plans/subSite/index.wxss */
.banner-wrapper {
    position: relative;

    .scroll-content {
        white-space: nowrap;
        overflow: auto;
        background-color: #ffffff;
        width: 100%;
        height: 150px;
        overflow: auto;
    }

    .banner-img {
        display: inline-block;
        width: 240px;
        height: 150px;
        margin-right: 6px;
        object-fit: cover;
    }
}

.single-img {
    display: inline-block;
    width: 100%;
    height: 150px;
    margin-right: 6px;
    object-fit: cover;
}

.check-album {
    width: 88px;
    height: 150px;
    display: inline-block;
    background-color: #ffe692;
    font-size: 12px;
    color: #222125;
    margin-left: -1px;
    position: relative;
}

.check-album .check-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.check-album .text {
    padding: 3px 0;
    text-align: center;
}

.check-album .text:first-child {
    border-bottom: 1px solid #222125;
}

.banner-wrapper .star-container {
    position: absolute;
    z-index: 10;
    right: 8px;
    bottom: -22rpx;
    display: flex;
    align-items: center;
    justify-content: center;
}

.star-wrapper {
    height: 42px;
}

.star-box image {
    width: 41px;
    height: 41px;
    display: block;
}

.intro-page .intro-brief {
    padding-top: 18px;
}

.rooms .rooms-title {
    font-size: 16px;
    padding-left: 24px;
    position: relative;
    margin-bottom: 7px;
    color: #222215;
    font-weight: bold;
    font-family: GothamBold;
}

.rooms .rooms-title:before {
    content: '';
    width: 3px;
    height: 17px;
    background-color: #f8a909;
    position: absolute;
    left: 12px;
    top: 3px;
}

.room-list .room-item:not(:first-child) {
    border-top: 1px solid #e4e4e4;
}

.date-select {
    color: #222125;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 12px;
    border-top: 8rpx solid #f0f0f0;
}

.select-trigger {
    padding: 20px 12px;
    display: flex;
    font-size: 14px;
    align-items: center;
}

.select-trigger image {
    width: 7px;
    height: 14px;
    display: block;
    margin-left: 6px;
}

.date-select .date-wrapper {
    display: flex;
    align-items: center;
}

.date-wrapper .date {
    font-size: 16px;
    line-height: 1em;
    margin-right: 5px;
}

.date-wrapper .marker {
    font-size: 10px;
    line-height: 1em;
    color: #d1d1d1;
}
</style>